import React, { useState, useEffect } from 'react'
import axios from 'axios'

const init = {
  method: 'get',
  url: ''
}

export function Api(init) {
  return useFetch(data => ({
    method: data && data.method ? data.method : init.method,
    url: data && data.url ? data.url : init.url,
    data: { ...data }
  }))
}

function useFetch(fn) {
  const [data, setData] = useState({
    error: null,
    loading: false,
    data: null
  })

  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  const [req, setReq] = useState(false)

  const call = (method, url, params) => {
    params.cancelToken = source.token

    if (method === 'post' || method === 'patch') {
      return axios[method](url, params)
    }

    return axios[method](url, params)
  }

  const getData = async () => {
    setData({ ...data, loading: true })
    try {
      const response = await call(req.method, req.url, req.data)
      setData({
        error: null, data: response.data, loading: false
      })
    } catch (error) {

      if (axios.isCancel(error)) {
        return
      }

      prepareErrors(error)

      setData({
        ...data, error: error, loading: false
      })
    }
  }

  useEffect(() => {
    req ? getData() : null

    return () => {
      source.cancel()
    }
  }, [req])

  return [data, (...args) => setReq(fn(...args))]
}

function prepareErrors(error) {
  if(!error.response) return

  switch (error.response.status) {
  case 429:
    error.response.data.errors = { error: ['Zbyt wiele prób, spróbuj ponownie za chwilę.'] }
    break
  case 500:
    error.response.data.errors = { error: ['Ups! Wygląda na to, że nasze serwery się przegrzały. Spróbuj ponownie później. Jeżeli błąd będzie się powtarzał poinformuj nas o tym.'] }
    break
  }
}
